<template>
    <div>
        <v-row>
            <v-col cols="12" sm="4" md="3">
                <v-select :items="[1, 5, 10, 25]"
                    v-model="page_size"
                    label="Resultados por página"
                    >
                </v-select>
            </v-col>
        </v-row>
        <v-row class="py-3 px-1">
            <v-btn color="secondary" elevation="0"
                @click.prevent="loadMore(StateLogsResetPasswordMoodle.next)"
                :disabled="StateLogsResetPasswordMoodle && !StateLogsResetPasswordMoodle.next">
                <v-icon small>mdi-arrow-left</v-icon> &nbsp; Mais antiga
            </v-btn>
            <v-btn color="success" elevation="0"
                @click.prevent="loadMore(StateLogsResetPasswordMoodle.previous)"
                :disabled="StateLogsResetPasswordMoodle && !StateLogsResetPasswordMoodle.previous">
                Mais recente &nbsp; <v-icon small>mdi-arrow-right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="get_logs"
                :disabled="StateLogsResetPasswordMoodleLoading"
                :loading="StateLogsResetPasswordMoodleLoading">
                <v-icon small>mdi-sync</v-icon>  Recarregar Logs
            </v-btn>
        </v-row>
        <v-card v-for="log, i in StateLogsResetPasswordMoodle.results" :key="i" class="my-1">
            <v-card-text>
                <div>
                    <div>Redefinido para: {{log.reseted_to}}</div>
                    <div>Redefinido por: {{log.reseted_by.username}} - {{log.reseted_by.first_name}}</div>
                    <div>Redefinido em: {{$verify.formatarData(log.reseted_at)}}</div>
                    <div>Moodle: {{log.moodle}}</div>
                </div>
                <div>
                    <code v-html="log.get_log" class="px-8"></code>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ConfigService from '../../services/index'
const configService = new ConfigService()
export default {
    name: 'MoodleUNDBLogResetPassword',
    data:()=>({
        page_size:1
    }),
    mounted(){
        this.get_logs()
    },
    methods:{
        ...mapActions(['GetLogsResetPasswordMoodleUNDB']),
        ...mapMutations(['SetLogsResetPasswordMoodle']),
        async loadMore(url){
            let response = await configService.genericGetRequest(url, {search: this.$route.query?.instancia})
            this.SetLogsResetPasswordMoodle(response.data)
        },
        get_logs(){
            const page_size = this.page_size
            this.GetLogsResetPasswordMoodleUNDB({page_size, search: this.$route.query?.instancia})
        }
    },
    computed:{
        ...mapGetters(['StateLogsResetPasswordMoodle','StateLogsResetPasswordMoodleLoading',])
    },
    watch:{
        page_size(){
            this.get_logs()
        }
    }
}
</script>